(function() {
  'use strict';

  const COLOR_MAP = {
      'Sage': '#7CB68E',
      'Sage Green': '#7CB68E',
      'Pearl': '#F5F0EB',
      'Cloud White': '#F5F0EB',
      'White': '#F5F0EB',
      'Glacier': '#8BA8B8',
      'Charcoal': '#2C2C2C',
      'Onyx': '#2C2C2C',
      'Canyon': '#C4725A'
    };

  // SVG placeholder for bundle thumbnails
  const BRUSH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="8" fill="#f0f0f0"/><rect x="22" y="8" width="4" height="28" rx="2" fill="#bbb"/><rect x="19" y="6" width="10" height="6" rx="2" fill="#999"/></svg>';
  const CASE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="8" fill="#f0f0f0"/><rect x="12" y="10" width="24" height="28" rx="4" fill="#bbb"/><rect x="22" y="8" width="4" height="4" rx="1" fill="#999"/><circle cx="24" cy="26" r="4" fill="#8BA8B8" opacity="0.7"/></svg>';

  function initColorSwatches() {
    const colorFieldset = document.querySelector('.variant-option--buttons:has(input[name*="Color"])');
    if (!colorFieldset) return;

    const labels = colorFieldset.querySelectorAll('.variant-option__button-label');
    labels.forEach(function(label) {
      if (label.querySelector('.arisson-color-dot')) return;
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      const colorName = input.value;
      const hex = COLOR_MAP[colorName];
      if (!hex) return;

      const dot = document.createElement('span');
      dot.className = 'arisson-color-dot';
      dot.style.backgroundColor = hex;
      if (colorName === 'Pearl') {
        dot.style.border = '1px solid #ddd';
      }
      label.appendChild(dot);
    });
  }

  function initBundleThumbnails() {
    const bundleFieldset = document.querySelector('.variant-option--buttons:has(input[name*="Bundle"])');
    if (!bundleFieldset) return;

    const labels = bundleFieldset.querySelectorAll('.variant-option__button-label');
    labels.forEach(function(label) {
      if (label.querySelector('.arisson-bundle-thumb')) return;
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      const val = input.value;

      var svgData;
      if (val.toLowerCase().includes('uv') || val.toLowerCase().includes('case')) {
        svgData = CASE_SVG;
      } else {
        svgData = BRUSH_SVG;
      }
      var img = document.createElement('div');
      img.className = 'arisson-bundle-thumb';
      img.innerHTML = svgData;
      label.insertBefore(img, label.firstChild);
    });
  }

  function initSubscriptionSection() {
    if (document.querySelector('#MainContent')?.dataset.template === 'product.mcf-products') return;
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    if (document.querySelector('.arisson-subscription-section')) return;

    var section = document.createElement('div');
    section.className = 'arisson-subscription-section';
    section.innerHTML = '<h3>Brush Head Refills</h3>'
      + '<label class="arisson-sub-option active">'
      + '  <input type="radio" name="arisson-sub" value="none" checked>'
      + '  <div class="arisson-sub-info">'
      + '    <div class="arisson-sub-title">One-time purchase</div>'
      + '    <div class="arisson-sub-desc">No subscription</div>'
      + '  </div>'
      + '  <div class="arisson-sub-price">Included</div>'
      + '</label>'
      + '<label class="arisson-sub-option">'
      + '  <input type="radio" name="arisson-sub" value="3month">'
      + '  <div class="arisson-sub-info">'
      + '    <div class="arisson-sub-title">Every 3 months</div>'
      + '    <div class="arisson-sub-desc">2-pack brush heads delivered quarterly</div>'
      + '  </div>'
      + '  <div class="arisson-sub-price">$12/quarter<span class="arisson-sub-save">Save 15%</span></div>'
      + '</label>'
      + '<label class="arisson-sub-option">'
      + '  <input type="radio" name="arisson-sub" value="6month">'
      + '  <div class="arisson-sub-info">'
      + '    <div class="arisson-sub-title">Every 6 months</div>'
      + '    <div class="arisson-sub-desc">4-pack brush heads delivered biannually</div>'
      + '  </div>'
      + '  <div class="arisson-sub-price">$22/6 months<span class="arisson-sub-save">Save 20%</span></div>'
      + '</label>';

    picker.parentNode.insertBefore(section, picker.nextSibling);

    var options = section.querySelectorAll('.arisson-sub-option');
    options.forEach(function(opt) {
      opt.addEventListener('click', function() {
        options.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        opt.querySelector('input').checked = true;
      });
    });
  }

  function init() {
    initColorSwatches();
    initBundleThumbnails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run on Shopify section render events (for AJAX navigation)
  document.addEventListener('shopify:section:load', init);

  // MutationObserver for dynamic content
  var observer = new MutationObserver(function(mutations) {
    var shouldInit = mutations.some(function(m) {
      return m.addedNodes.length > 0;
    });
    if (shouldInit) {
      requestAnimationFrame(init);
    }
  });
  var target = document.querySelector('main') || document.body;
  observer.observe(target, { childList: true, subtree: true });
})();